import { Guid } from "guid-typescript";

import { ValidationIssueSeverity } from "infrastructure/validation";
import { extractApiErrorMessageContent, IApiError } from "ui/shared/models/common";

import { ITermTranslationsUploadResponseItem } from "./TermTranslationsUpload.api";
import { ITermTranslationsUploadValidationIssue, ITermTranslationsUploadError } from "./TermTranslationsUpload.state";

export const getValidationIssues = (response: ITermTranslationsUploadResponseItem[]): ITermTranslationsUploadValidationIssue[] => {
  return (
    response &&
    response.map<ITermTranslationsUploadValidationIssue>(e => {
      return {
        uniqueId: e.uniqueId ? e.uniqueId : Guid.raw(),
        key: e.key,
        locale: e.locale,
        industry: e.industry,
        translationId: e.translationId,
        termTranslation: e.termTranslation,
        definitionTranslation: e.definitionTranslation,
        validationIssue: {
          severity: ValidationIssueSeverity.Error,
          message: extractApiErrorMessageContent(e.error)
        }
      };
    })
  );
};

export const getUploadValidationError = (response: ITermTranslationsUploadResponseItem[] | IApiError): ITermTranslationsUploadError => {
  const validationResult: ITermTranslationsUploadError = Array.isArray(response)
    ? {
        validationIssues: getValidationIssues(response)
      }
    : {
        text: extractApiErrorMessageContent(response)
      };

  return validationResult;
};
